const OrdersLoader = ({ len }: { len?: number }) => {
  return (
    <>
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Card Type</th>
              <th>Order Hash</th>
              <th>Amount</th>
              <th>Type</th>
              <th>Status</th>
              <th>Dispute</th>
              <th className="text-center">Date</th>
            </tr>
          </thead>
          <tbody>
            {new Array(len || 10).fill(null).map((_, i) => (
              <tr key={i}>
                <td>
                  <div className="transaction-label">
                    <div className="transaction-label__icon-box br-0 placeholder"></div>
                    <p className="bold color-transparent placeholder">
                      Naira Transfer
                    </p>
                  </div>
                </td>
                <td>
                  <span className="color-transparent placeholder">
                    #ORDER-RBCSB20230621226
                  </span>
                </td>
                <td>
                  <span className="color-transparent placeholder">
                    $33 (&#8358;21,450)
                  </span>
                </td>
                <td>
                  <span className="color-transparent placeholder"> Sell </span>
                </td>
                <td>
                  <span className="badge color-transparent placeholder">
                    Paid
                  </span>
                </td>
                <td>
                  <span className="color-transparent placeholder">
                    No Dispute
                  </span>
                </td>
                <td>
                  <div className="transaction-date">
                    <p>
                      <span className="color-transparent placeholder">
                        Jun, 22 2023
                      </span>
                    </p>
                    <p>
                      <span className="color-transparent placeholder">
                        12:00:39 PM
                      </span>
                    </p>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="transactions-flex">
        {new Array(len || 10).fill(null).map((_, i) => (
          <div className="transaction-mobile" key={i}>
            <div className="transaction-label">
              <div className="transaction-label__icon-box placeholder"></div>
            </div>
            <div className="transaction-mobile__main">
              <p className="transaction-mobile__type">
                <span className="color-transparent placeholder">
                  Naira Transfer
                </span>
              </p>
              <p className="transaction-mobile__text">
                <span className="color-transparent placeholder">
                  Sent &#8358;6,400 to dessy
                </span>
              </p>
              <p className="transaction-mobile__hash">
                <span className="color-transparent placeholder">
                  #JJHAII****jJKAJSKAS
                </span>
              </p>
            </div>
            <div className="transaction-mobile__right">
              <p className="transaction-mobile__amount text-success">
                <span className="color-transparent placeholder">
                  + &#8358;2,000.00
                </span>
              </p>
              <p className="transaction-mobile__date">
                <span className="color-transparent placeholder">
                  {" "}
                  Jun 22, 2023{" "}
                </span>
              </p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default OrdersLoader;
